import { BrowserRouter, Route, Routes } from "react-router-dom";
import ViewAprueboRechazo  from "./pages/apruebo-rechazo/ViewAprueboRechazo";
import ViewGobierno from "./pages/gobierno/ViewGobierno";
import ViewMarcasCiudadanas from "./pages/marcas-ciudadanas/ViewMarcasCiudadanas";
import NotFoundPage from "./Components/notFound/NotFoundPage";

import ViewLogin from "./pages/Login/ViewLogin";
import ViewCarga from "./pages/Carga/ViewCarga";
import ViewAprueboV2 from "./pages/apruebo-rechazo/apruebo-rechazov2/ViewAprueboV2";
import ViewConocimiento from "./pages/conocimiento/ViewConocimiento";
import ViewImagenPositiva from "./pages/imagen-positiva/ViewImagen-positiva";
import ViewFigurasPublicas from "./pages/figuras-publicas/ViewFiguras-Publicas";
import ViewMinisterio from "./pages/Ministerio-conocimiento/ViewMinisterio";
import ViewMinisterioAP from "./pages/Ministerio-aprobacion/ViewMinisterio-aprobacion";
import ViewDesempeno from "./pages/desempeno-politico/ViewDesempeno-politico";
import ViewModeloConfianza from "./pages/modelo-confianza/ViewModeloConfianza";
import ViewEnuscV2 from "./pages/enusc/enusc-v2/ViewEnuscV2";
import ViewIndustriasV2 from "./pages/industrias/industrias-v2/ViewIndustriasV2";

import ViewInstitucionesV2 from "./pages/instituciones/instituciones-v2/ViewInstitucionesV2";
import ViewDelincuenciaV2 from "./pages/delincuencia/delincuencia-v2/ViewDelincuenciaV2";
import ViewImagenPositivaV2 from "./pages/imagen-positiva/imagen-positiva-v2/ViewImagen-positivaV2";
import ViewConocimientoV2 from "./pages/conocimiento/conocimiento-v2/ViewConocimientoV2";
import ViewEconomiaV2 from "./pages/economia/economia-v2/ViewEconomiaV2";
import ViewMinisterioV2 from "./pages/Ministerio-conocimiento/Ministerio-conocimiento-v2/ViewMinisterioV2";
import ViewMinisterioAPv2 from "./pages/Ministerio-aprobacion/Ministerio-aprobacion-v2/ViewMinisterio-aprobacionV2";
import ViewPazCiudadanaV2 from "./pages/paz-ciudadana/paz-ciudadana-v2/ViewPazCiudadanaV2";
import ViewModeloConfianzaV2 from "./pages/modelo-confianza/modelo-confianza-v2/ViewModeloConfianzaV2";
import ViewAprueboRechazoV3 from "./pages/apruebo-rechazo/apruebo-rechazo-v3/ViewAprueboRechazoV3";

import ViewConfianzaCademV2 from "./pages/confianza-empresa-cadem/confianza-empresa-cademv2/ViewConfianza-empCademV2";
import ViewConfianzaCep from "./pages/confianza-empresa-cep/ViewConfianza-empCep";
import ViewConfianzaCepV2 from "./pages/confianza-empresa-cep/confianza-empresa-cep-v2/ViewConfianza-empCepV2";
import ViewReformaPensionesV2 from "./pages/reforma-pensiones/reforma-pensiones-v2/ViewReformaPensionesV2";
import ViewAprobacionMensual from "./pages/aprobacion-mensual/ViewAprobacion-mensual";
import ViewConfianzaPresidente from "./pages/confianza-presidente/ViewConfianzaPresidente";
import ViewNuevaConstitucion from "./pages/nueva-constitucion/ViewNuevaConstitucion";
import ViewNuevaConstitucionV2 from "./pages/nueva-constitucion/nueva-constitucion-v2/ViewNuevaConstitucionv2";
import ViewAtributosPersonales from "./pages/Atributos personales/ViewAtributosPersonales";
import ViewEquipoGobierno from "./pages/equipo-gobierno/ViewEquipoGobierno";
import ViewProyectoGraficos from "./pages/proyecto-graficos/ViewProyectoGraficos";
import ViewProyectoGraficosV2 from "./pages/proyecto-graficos/proyecto-graficos-v2/ViewProyectoGraficosV2";

import ViewAtributosGestion from "./pages/atributos-gestion/viewAtributosGestion";
import ViewAtributosPoliticos from "./pages/atributos-politicos/viewAtributosPoliticos";
import ViewInflacionMundial from "./pages/inflacion-mundial/ViewInflacionMundial";
import ViewIMAprob from "./pages/IMACEC-VS-aprob/ViewIM-Aprob";
import ViewGraficoDoble from "./pages/grafico-doble/ViewGraficoDoble";
import ViewIPCVSAP from "./pages/IPC-vs-ap/ViewIPCVSAP";
import Viewimacecper from "./pages/imacec-vs-percepcion/ViewImacecPerc";
import ViewDesempleoexp from "./pages/desempleo-vs-expectativas/ViewDesempleoexp";

import ViewConocimientoAprobacion from "./pages/Conocimiento-Aprobacion/ViewConocimientoAprobacion";
import ViewPlebiscito from "./pages/plebiscito-salida/ViewPlebiscito";
import ViewPreferenciaPresidencial from "./pages/preferencia-presidencial/ViewPreferenciaPresidencial";
import ViewIntencionVoto from "./pages/intencion-voto/ViewIntencionVoto";
import ViewSeguimientoConstituyente_SOLO2023 from "./pages/SeguimientoConstituyente_SOLO2023/ViewSeguimientoConstituyente_SOLO2023";
import ViewEleccienesDiciembre2023 from "./pages/eleccienes-diciembre-2023/ViewEleccienesDiciembre2023";


import ViewPercepciones11Sep from "./pages/percepciones-11-septiembre/ViewPercepciones11Sep";


import ViewImagenPaises from "./pages/imagen-paises/ViewImagenPaises";


import ViewDependientevsIndependiente from "./pages/dependiente_vs_independiente/ViewDependientevsIndependiente";
import ViewConocimientoVsImagenRostrosTV from "./pages/conocimiento-vs-imagen-rostros-tv/ViewConocimientoVsImagenRostrosTV";
import ViewRecordacionRostrosPublicitarios from "./pages/recordacion-rostros-publicitarios/ViewRecordacionRostrosPublicitarios";
import ViewLugaresCompra from "./pages/lugares-compra/ViewLugaresCompra";
import ViewRecuerdoGuiadoMarcas from "./pages/recuerdo-guiado-marcas/ViewRecuerdoGuiadoMarcas";
import ViewPercepcionAbuso from "./pages/percepcion-abuso/ViewPercepcionAbuso";
import ViewGastoHogaresClaseMedia from "./pages/gasto-hogares-clase-media/ViewGastoHogaresClaseMedia";
import ViewFelicidadEstadoDeAnimo from "./pages/felicidadEstadoDeAnimo/ViewFelicidadEstadoDeAnimo";
import ViewExpectitivas2024 from "./pages/expectativas2024/ViewExpectativa2024";
import ViewRecuerdoGuiadoMarcasTeleton from "./pages/recuerdo-guiado-marcas-teleton/ViewRecuerdoGuiadoMarcas";
import ViewEvaluacionPaisGobiernosMarzo2024 from "./pages/evaluacionPaisGobiernosMarzo2024/ViewEvaluacionPaisGobiernosMarzo2024";
import ViewRecordatorioEspontaneoMarcaFestival2024 from "./pages/recordatorio-espontaneo-marcas-festival2024/ViewRecordatorioEspontaneoMarcaFestival2024";
import ViewAreasPrioritariasGobierno from "./pages/areas-prioritarias-gobierno/ViewAreasPrioritariasGobierno";
import ViewCantidadAutomoviles from "./pages/cantidad-automoviles/ViewCantidadAutomoviles";
import ViewAcuerdoSQMCodelco from "./pages/acuerdo-SQM-Codelco/ViewAcuerdoSQMCodelco";

import ViewFutbolistaMasDestacado from "./pages/futbolista-mas-destacado/ViewMontoGastarVacaciones";
import ViewRolMediosDemocracias from "./pages/rol-medios-democracias/ViewRolMediosDemocracias";

import ViewImagenPositivaRostroPublicitario2024 from "./pages/imagen-positiva-rostro-publicitario-2024/ViewImagenPositivaRostroPublicitario2024";
import ViewConocimientosRostrosPublicitarios2024 from "./pages/conocimientos-rostros-publicitarios-2024/ViewConocimientosRostrosPublicitarios2024";
import ViewNivelAgradoRostrosPublicitarios2024 from "./pages/nivel-agrado-rostros-publicitarios-2024/ViewNivelAgradoRostrosPublicitarios2024";
import ViewAprobacionPresidencialV2New from "./newpages/aprobacion-precidencial-v2-new/viewAprobacion-precidencial-v2-new";
import DefaultViewLine from "./newpages/defaultViewLine";
import DefaultViewPie from "./newpages/defaulViewPie";
import ViewObjetivosPara2024 from "./newpages/objetivos-para-2024/viewObjetivosPara2024";
import ViewMedidasSeguridadMarzo2024 from "./newpages/medidas-seguridad-marzo-2024/viewMedidasSeguridadMarzo2024";

import ViewProhibirSeleccionEducacion from "./newpages/efecto-prohibir-seleccion-educacion/viewEfecto-prohibir-seleccion-educacion";
import ViewAvancesDelFeminismo from "./newpages/avances-del-feminismo/avances-del-feminismo";
import GraficoElecciones from "./newpages/graficoElecciones/graficoElecciones";
import GraficoEleccionesmMVPTest from "./newpages/graficoEleccionesMvpTest/graficoEleccionesMvpTest";
import GraficoEleccionesmEcenario2Vuelta from "./newpages/graficoEleccioneEceneario2vuelta/graficoEleccioneEceneario2vuelta";

import ViewCargaPagina from "./pages/CargaGraficoPagina/ViewCargaPagina";
import ViewGraficoDinamic from "./pages/Crear-grafico-dinamic/ViewCarga";
import ViewDefaultBar from "./newpages/defaultViewBar";
import { useEffect, useState } from "react";
import axios from "axios";
import { API_URL_LOCALE_BASE } from "./configuration/config";
import GraficoPersonajeSemana from "./newpages/graficoPersonajesSemana/graficoPersonajesSemana";
import GraficoRankingSemana from "./newpages/graficoRankingSemana/graficoGraficoSemana";
import CargaGraficoFiltro from "./newpages/carga-grafico-filtro/cargaGraficoFiltro";
import GraficoPrioridadesCiudadanasGobierno from "./newpages/graficoPrioridadesCiudadanasGobierno/graficoPrioridadesCiudadanasGobierno";
import ActualizarGraficoFiltro from "./newpages/actualizar-grafico-filtro/ActualizarGraficoFiltro";
import GraficoPercepcionDelincuenciaChile from "./newpages/percepcion-delincuencia-chile/percepcion-delincuencia-chile";
import MiniBox from "./newpages/miniBox/miniBox";

interface Props {
  cantidadDecimal: number;
    disableFilter:   boolean;
    formatoGraph:    string;
    id:              number;
    idGraficoData:   number;
    labelGrafico:    string;
    mostrarDatos:    boolean;
    mostrarLinea:    boolean;
    mostrarPie:      boolean;
    nombreGrafico:   string;
    path:            string;
    pieTexto:        string;
    subtitulo:       string;
    tipoGraph:       number;
    tituloGraph:     string;
    arrayValues:     any;
    titleY:          string;
    mostrarNegativos : boolean;
    mostrarlegend:boolean;
    isRevertGraphY:boolean;
    isThousandFormat:boolean;
    isMiniGraph:boolean;
    isYAxisActive: boolean;
    yAxisMax:number;

}
const selectCrimenExtenienteOjeda = [
  {
      "label": "Fue un crimen con motivaciones políticas encargado por Venezuela",
      "value": "Fue un crimen con motivaciones políticas encargado por Venezuela"
  },{
    "label": "Fue un crimen organizado por bandas relacionadas al narcotráfico",
    "value": "Fue un crimen organizado por bandas relacionadas al narcotráfico"
}
,{
  "label": "Ns/Nr",
  "value": "Ns/Nr"
}

];

// const rutas:[Props] = [
  
//   // Agrega más objetos según sea necesario
// ];

const AppRouter: React.FC<{}> = () => {
  const [rutas, setRuta] = useState([])

  useEffect(() => {
    axios.post( API_URL_LOCALE_BASE + 'get-grafico-dinamicos',{}).then( async (response:any) =>{
      let {data} = response;
      console.log('1. RESPONSE DATA', response.data.data)
      if(parseInt(data.status) === 200){
        console.log('VALOR',data.data);
        setRuta(data.data)
        
       
      } else {
        
      }
  });
    
  }, [])
  
  // <BrowserRouter>
  // <>
  return (
      <Routes>
        <Route path="/areas-prioritarias-gobierno" element={ <ViewAreasPrioritariasGobierno/> }/>
        <Route path="/marcas-ciudadanas" element={ <ViewMarcasCiudadanas/> }/>
        <Route path="/plebiscito-salida-2023" element={ <ViewPlebiscito/> }/>
        <Route path="/expectitivas-2024" element={ <ViewExpectitivas2024/> }/>
        <Route path="/intencion-voto" element={ <ViewIntencionVoto/> }/>
        <Route path="/preferencia-presidencial-2025" element={ <ViewPreferenciaPresidencial/> }/>
        <Route path="/grafico-doble-demo" element={ <ViewGraficoDoble/> }/>

        <Route path="/conocimiento-vs-aprobacion" element={ <ViewConocimientoAprobacion/> }/>
        <Route path="/Seguimiento-constituyente-2023" element={ <ViewSeguimientoConstituyente_SOLO2023/> }/>
        <Route path="/elecciones-diciembre-2023" element={ <ViewEleccienesDiciembre2023/> }/>
        <Route path="/imacec-vs-percepcion" element={ <Viewimacecper/> }/>
        <Route path="/desempleo-vs-expectativas" element={ <ViewDesempleoexp/> }/>
        <Route path="/ipc-vs-aprob" element={ <ViewIPCVSAP/> }/>
        <Route path="/imacec-aprob" element={ <ViewIMAprob/> }/>
        <Route path="/atributos-gestion" element={ <ViewAtributosGestion/> }/>
        <Route path="/atributos-politicos" element={ <ViewAtributosPoliticos/> }/>
        <Route path="/inflacion-mundial" element={ <ViewInflacionMundial/> }/>
        <Route path="/apresidencial-sitacionp" element={ <ViewProyectoGraficos />} />
        <Route path="/apresidencial-sitacionp-v2" element={ <ViewProyectoGraficosV2 />} />
        <Route path="/industrias-v2" element={ <ViewIndustriasV2 />} />
        <Route path="/equipo-gobierno" element={ <ViewEquipoGobierno />} />
        <Route path="/atributos-personales" element={ <ViewAtributosPersonales />} />
        <Route path="/aprobacion-mensual-presidente" element={ <ViewAprobacionMensual />} />
        <Route path="/confianza-en-el-presidente" element={ <ViewConfianzaPresidente />} />
        <Route path="/nueva-constitucion" element={ <ViewNuevaConstitucion />} />
        <Route path="/nueva-constitucion-v2" element={ <ViewNuevaConstitucionV2 />} />
        <Route path="/apruebo-rechazo" element={ <ViewAprueboRechazo />} />
        <Route path="/apruebo-rechazoV2" element={ <ViewAprueboV2 />} />
        <Route path="/apruebo-rechazo-v3" element={ <ViewAprueboRechazoV3 />} />
        <Route path="/gobierno" element={ <ViewGobierno />} />

        <Route path="/instituciones-v2" element={ <ViewInstitucionesV2 />} />

        <Route path="/desempeno-politico" element={ <ViewDesempeno />} />
        <Route path="/delincuencia-cadem-v2" element={ <ViewDelincuenciaV2 />} />
        <Route path="/conocimiento" element={ <ViewConocimiento />} />
        <Route path="/conocimiento-v2" element={ <ViewConocimientoV2 />} />
        <Route path="/modelo-confianza" element={ <ViewModeloConfianza />} />
        <Route path="/modelo-confianza-v2" element={ <ViewModeloConfianzaV2 />} />
        <Route path="/imagen-positiva" element={ <ViewImagenPositiva />} />
        <Route path="/imagen-positiva-v2" element={ <ViewImagenPositivaV2 />} />
        <Route path="/figuras-publicas" element={ <ViewFigurasPublicas />} />
        <Route path="/economia-v2" element={ <ViewEconomiaV2 />} />
        <Route path="/enusc-v2" element={ <ViewEnuscV2 />} />
        <Route path="/paz_cuidadana-v2" element={ <ViewPazCiudadanaV2 />} />
        <Route path="/ministerio-conocimiento" element={ <ViewMinisterio />} />
        <Route path="/ministerio-conocimiento-v2" element={ <ViewMinisterioV2 />} />
        <Route path="/ministerio-aprobacion" element={ <ViewMinisterioAP />} />
        <Route path="/ministerio-aprobacion-v2" element={ <ViewMinisterioAPv2 />} />
        <Route path="/reforma-pensiones-v2" element={ <ViewReformaPensionesV2 />} />
        <Route path="/confianza-empresa-cadem-v2" element={ <ViewConfianzaCademV2 />} />
        <Route path="/confianza-empresa-cep" element={ <ViewConfianzaCep />} />
        <Route path="/confianza-empresa-cep-v2" element={ <ViewConfianzaCepV2 />} />
        <Route path="/percepciones-11-septiembre" element={ <ViewPercepciones11Sep />} />

        <Route path="/imagen-paises" element={ <ViewImagenPaises/> }/>
        <Route path="/dependiente_vs_independiente" element={ <ViewDependientevsIndependiente/> }/>
        <Route path="/felicidad_estado_de_animo" element={ <ViewFelicidadEstadoDeAnimo/> }/>
        <Route path="/conocimiento-vs-imagen-rostros-tv" element={ <ViewConocimientoVsImagenRostrosTV/> }/>
        <Route path="/recordacion-rostros-publicitarios" element={ <ViewRecordacionRostrosPublicitarios/> }/>
        <Route path="/lugares-compra" element={ <ViewLugaresCompra/> }/>
        <Route path="/recuerdo-guiado-marcas" element={ <ViewRecuerdoGuiadoMarcas/> }/>
        <Route path="/percepcion-abuso" element={ <ViewPercepcionAbuso/> }/>
        <Route path="/gasto-hogares-clase-media" element={ <ViewGastoHogaresClaseMedia/> }/>
        <Route path="/recuerdo-guiado-marcas-teleton" element={ <ViewRecuerdoGuiadoMarcasTeleton/> }/>
        <Route path="/cantidad-automoviles" element={ <ViewCantidadAutomoviles/> }/>
        <Route path="/acuerdo-SQM-Codelco" element={ < ViewAcuerdoSQMCodelco/> }/>
        <Route path="/futbolista-mas-destacado" element={ <ViewFutbolistaMasDestacado/> }/>
        <Route path="/rol-medios-democracias" element={ <ViewRolMediosDemocracias/> }/>
        <Route path="/imagen-positiva-rostro-publicitario-2024" element={ <ViewImagenPositivaRostroPublicitario2024/> }/>
        <Route path="/conocimientos-rostros-publicitarios-2024" element={ <ViewConocimientosRostrosPublicitarios2024/> }/>
        <Route path="/nivel-de-agrado-rostros-publicitarios-2024" element={ <ViewNivelAgradoRostrosPublicitarios2024/> }/>
        <Route path="/aprobacion-presidencial" element={ <ViewAprobacionPresidencialV2New/>} />
        <Route path="/efecto-prohibir-seleccion-educacion" element={ <ViewProhibirSeleccionEducacion/> }/>
        <Route path="/avances-del-feminismo" element={ <ViewAvancesDelFeminismo/> }/>
        <Route path="/evaluacion-tras-gobierno-marzo2024" element={ <ViewEvaluacionPaisGobiernosMarzo2024/> }/>
        <Route path="/ObjetivosPara2024" element={ <ViewObjetivosPara2024/> }/>
        <Route path="/medidas-seguridad-2024" element={ <ViewMedidasSeguridadMarzo2024/> }/>
        <Route path="/recordacion-espontanea-marcas-festival2024" element={ <ViewRecordatorioEspontaneoMarcaFestival2024/> }/>
        <Route path="/grafico-elecciones" element={ <GraficoElecciones/> }/>
        <Route path="/grafico-elecciones-test-mvp" element={ <GraficoEleccionesmMVPTest/> }/>
        <Route path="/grafico-elecciones-ecenario-2-vuelta" element={ <GraficoEleccionesmEcenario2Vuelta/> }/>
        <Route path="/grafico-personaSemana" element={ <GraficoPersonajeSemana/> }/>
        <Route path="/grafico-ranking-semana" element={ <GraficoRankingSemana/> }/>
        <Route path="/login" element={ <ViewLogin />} />
        <Route path="/carga" element={ <ViewCarga />} />
        <Route path="/cargaPagina" element={ <ViewCargaPagina />} />
        <Route path="/grafico-filtro" element={ <CargaGraficoFiltro />} />
        <Route path="/actualizar-grafico-filtro" element={ <ActualizarGraficoFiltro />} />

        <Route path="/prioridades-ciudadanas" element={ <GraficoPrioridadesCiudadanasGobierno />} />
        <Route path="/percepcion-delincuencia-chile" element={ <GraficoPercepcionDelincuenciaChile />} />
        <Route path="/test-mini-box" element={ <MiniBox />} />

        <Route path="/crear-grafico-dinamic" element={ <ViewGraficoDinamic />} />


        {/* {rutas.map((ruta:Props, index) => (
          
          <Route key={index} path={ruta.path} element={<DefaultViewPiehart idTipoGraficoProps={ruta.id} nameTitleProps={ruta.nombreGrafico} tituloProps={ruta.tituloGraph} selectValueProsp={selectCrimenExtenienteOjeda} subtitleProps={ruta.subtitulo}  disableFilterProps={ruta.disableFilter} />} />
        ))} */}
 {rutas.map((ruta:Props, index) => {
          if(ruta.tipoGraph ==1){
            return           <Route key={index} path={ruta.path} element={<DefaultViewLine  idTipoGraficoProps={ruta.idGraficoData} nameTitleProps={ruta.labelGrafico} tituloProps={ruta.tituloGraph} selectValueProsp={ruta.arrayValues} subtitleProps={ruta.subtitulo}  disableFilterProps={ruta.disableFilter} formatDataStringData={ruta.formatoGraph} numDecimalProps={ruta.cantidadDecimal}  pieTextProps={ruta.pieTexto} showPieTextInGraph={ruta.mostrarPie}  showSeries={ruta.mostrarDatos} mostrarlegend={ruta.mostrarlegend} isRevertGraphY={ruta.isRevertGraphY} isThousandFormat={ruta
            .isThousandFormat} enableMiniBox={ruta.isMiniGraph} isYAxisActive={ruta.isYAxisActive}/>} />

          }
          if(ruta.tipoGraph ==2){
            return           <Route key={index} path={ruta.path} element={<DefaultViewPie idTipoGraficoProps={ruta.idGraficoData} nameTitleProps={ruta.labelGrafico} tituloProps={ruta.tituloGraph} selectValueProsp={ruta.arrayValues} subtitleProps={ruta.subtitulo}  disableFilterProps={ruta.disableFilter} formatDataStringData={ruta.formatoGraph} numDecimalProps={ruta.cantidadDecimal} pieTextProps={ruta.pieTexto}  showPieTextInGraph={ruta.mostrarPie}  enableMiniBox={ruta.isMiniGraph}/>} />

          }
          if(ruta.tipoGraph ==3){
            return           <Route key={index} path={ruta.path} element={<ViewDefaultBar idTipoGraficoProps={ruta.idGraficoData} nameTitleProps={ruta.labelGrafico} tituloProps={ruta.tituloGraph} selectValueProsp={ruta.arrayValues} subtitleProps={ruta.subtitulo}  disableFilterProps={ruta.disableFilter}formatDataStringData={ruta.formatoGraph}  numDecimalProps={ruta.cantidadDecimal} pieTextProps={ruta.pieTexto} titleY={ruta.titleY}  showPieTextInGraph={ruta.mostrarPie}  mostrarNegativos={ruta.mostrarNegativos} mostrarlegend={ruta.mostrarlegend} enableMiniBox={ruta.isMiniGraph} isYAxisActive={ruta.isYAxisActive} yAxisMax={ruta.yAxisMax} />} />

          }
 })}
        <Route path="*"  element={ <NotFoundPage />}/>
      </Routes>
  )
}
// </>
{/* </BrowserRouter> */}


export default AppRouter
